import React from "react";

// The how-to-play video for a Pool Type, next to the customer care panel.
const VideoAndAssistance = ({ videoId }) => {
  return (
    <div className="row">
      <div className="large-6 columns">
        <div className="flex-video">
          <iframe
            title="Video"
            width="420"
            height="315"
            src={`https://www.youtube.com/embed/${videoId}?rel=0`}
            frameBorder="0"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
          ></iframe>
        </div>
      </div>
      <div className="large-6 columns">
        <div className="panel">
          <h2>For Assistance or More Info:</h2>
          <p>
            Contact our customer care on 0861 444 822 or send us a mail or send us a <a href="mailto:Customercare@4racing.com">mail</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default VideoAndAssistance;
